import React from 'react';

import { Box } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material/styles';

import useWindowSize from 'global-components/screenSize/useWindowSize';
import { ExtraSmallScreenWidthBreakpoint } from 'global-components/theme/OhsLayoutConstants';

export const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    backgroundColor: theme.palette.custom?.MAIN_BG_COLOR,
    minHeight: '100vh',
  },
}));

type Props = {
  children: React.ReactNode;
};

export default function OhsModuleBackground(props: Props) {
  const { classes } = useStyles();
  const screenSize = useWindowSize();

  return (
    <Box p={screenSize.width < ExtraSmallScreenWidthBreakpoint ? 2 : 3} className={classes.root}>
      {props.children}
    </Box>
  );
}
